var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#FFF", fillRule: "evenodd", d: "M15.24 4.15a1 1 0 1 1 1.52-1.3l3 3.5a1 1 0 0 1 0 1.3l-3 3.5a1 1 0 0 1-1.52-1.3L16.827 8H14.5C12.569 8 11 9.57 11 11.5V15a1 1 0 0 1-2 0v-3.5C9 8.466 11.464 6 14.5 6h2.326L15.24 4.15zM19 14.03a1 1 0 1 1 2 0v3.973A2.996 2.996 0 0 1 18.005 21H5.995A3 3 0 0 1 3 17.994V9.006A3.006 3.006 0 0 1 5.994 6H6.5a1 1 0 1 1 0 2h-.506C5.452 8 5 8.453 5 9.006v8.988A1 1 0 0 0 5.995 19h12.01c.55 0 .995-.446.995-.997v-3.974z" })
  );
});